const closeButton = document.querySelector(".contact-form__btn.close");
const contactForm = document.querySelector(".contact-form");
const form = document.querySelector(".contact-form__form");
const formHeader = document.querySelector(".contact-form__header");
const submitButton = document.querySelector(".contact-form__button");
const successMessage = document.querySelector(".success-message");

/**
 * Скрываем форму.
 * @param {HTMLFormElement} form - Элемент формы.
 * @param {HTMLElement} formHeader - Заголовок формы.
 * @param {HTMLElement} closeButton - Кнопка закрытия.
 */
function hideContactForm() {
  form.style.display = "none";
  formHeader.style.display = "none";
  closeButton.style.display = "";
}

/**
 * Показываем сообщение об успехе.
 * @param {HTMLFormElement} contactForm - Форма контактов.
 * @param {HTMLElement} successMessage - Сообщение об успехе.
 * @param {HTMLElement} closeButton - Кнопка закрытия.
 */
function showSuccessMessage() {
  contactForm.style.display = "flex";
  successMessage.style.display = "flex";
  successMessage.setAttribute("data-success", true);
  closeButton.style.display = "";
}

/**
 * Скрываем сообщение об успехе и показывает форму.
 * @param {HTMLElement} successMessage - Сообщение об успехе.
 * @param {HTMLElement} formHeader - Заголовок формы.
 * @param {HTMLFormElement} form - Элемент формы.
 * @param {HTMLElement} closeButton - Кнопка закрытия.
 */
function hideSuccessMessage() {
  successMessage.removeAttribute("data-success");
  successMessage.style.display = "none";
  formHeader.style.display = "flex";
  form.style.display = "flex";
  closeButton.style.display = "flex";
}

function setLoadingState(isLoading) {
  if (isLoading) {
    submitButton?.classList.add("loading");
  } else {
    submitButton?.classList.remove("loading");
  }
}

export {
  hideContactForm,
  hideSuccessMessage,
  setLoadingState,
  showSuccessMessage,
};
